// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brpNl,.brpNl .yFTOm,.brpNl .yFTOm [id^=adfox],.brpNl .ktDmS{width:300px;height:200px}.dk1eR{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adfoxInformer": "brpNl",
	"adfox": "yFTOm",
	"informer": "ktDmS",
	"loader": "dk1eR"
};
module.exports = ___CSS_LOADER_EXPORT___;
